import { MaintenanceStatus } from '@/services/maintenances-service/maintenances-service.types';
import styles from './maintenance-status-chip.module.scss';

interface MaintenanceStatusChipProps {
  status: string;
}

export default function MaintenanceStatusChip({ status }: MaintenanceStatusChipProps) {
  const normalizedStatus = status.toLowerCase() as MaintenanceStatus;

  return (
    <div
      className={`${styles.status} ${
        normalizedStatus === 'open'
          ? styles.statusOpen
          : normalizedStatus === 'closed'
            ? styles.statusClose
            : styles.statusInProgress
      }`}
    >
      {normalizedStatus === 'open' ? 'Open' : normalizedStatus === 'closed' ? 'Closed' : 'WIP'}
    </div>
  );
}
